<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">图标</div>
            <el-upload
                action=""
                :limit="1"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-progress="onProgress"
                :on-success="imgSuccess"
                :on-error="imgError"
                :http-request="uploadHttp"
                list-type="picture-card"
                :on-remove="handleRemove"
                :class="{disabled:uploadDisabled}"
                :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
              <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
            </el-dialog>

          </el-col>
          <el-col :span="12" class="item">
            <div class="label">活动分类</div>
            <el-select v-model="activityClassCode" filterable clearable placeholder="请选择活动分类" style="width: 100%">
              <el-option
                  v-for="item in activityClassList"
                  :key="item.activityClassCode"
                  :label="item.name"
                  :value="item.activityClassCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">活动内容</div>
            <el-input v-model="add_Name" placeholder="请输入活动内容"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">频次</div>
            <el-input v-model="add_frequency" placeholder="请输入频次"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">志愿队伍</div>
            <el-select v-model="volunteerTeamCode" filterable clearable placeholder="请选择志愿队伍" style="width: 100%">
              <el-option
                  v-for="item in volunteerTeamList"
                  :key="item.volunteerTeamCode"
                  :label="item.name"
                  :value="item.volunteerTeamCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getGovernmentCode, getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Name:'',
      add_frequency:'',
      add_imgPath:'',


      activityClassList:[],
      activityClassCode:'',

      volunteerTeamList:[],
      volunteerTeamCode:'',


      //上传身份证正面相关参数
      limitCount: 1,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

    }
  },
  methods: {


    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
      this.uploadDisabled = false;
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = true;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
      this.uploadDisabled = true;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.uploadDisabled = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file,fileList);
      this.uploadDisabled = false;
    },
    //图片更改
    handleChange(fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
      this.uploadDisabled = true;
    },
    uploadHttp(file) {

      //获取文件信息
      //let fileLen = file.file;
      //let name = fileLen.name

      console.log(file);
      console.log(file.file);

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.add_imgPath = that.$imgUrl+res.data.data.path;
      })


    },


    init(){

      this.add_Name = '';
      this.add_sort = '';
      this.volunteerTeamCode = '';
      this.add_imgPath = '';


      this.getVolunteerTeamList();
      this.getClassList();

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.activityClassCode === ''){
        this.$message("请选择活动分类");
        return;
      }
      if(this.add_Name === ''){
        this.$message("请输入活动内容名称");
        return;
      }
      if(this.add_frequency === ''){
        this.$message("请输入频次");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityContent/GovAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          name: this.add_Name,
          frequency:this.add_frequency,
          activityClassCode:this.activityClassCode,
          imgPath:this.add_imgPath.replace(this.$imgUrl,""),
          volunteerTeamCode:this.volunteerTeamCode,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    getVolunteerTeamList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/GovList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          //applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.volunteerTeamList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityClass/GovList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.activityClassList = response.data.data.list;

          if(this.activityClassList.length>0){
            //this.activityClassCode = this.activityClassList[0].activityClassCode;
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>


